import BannerUserInfos from '../bannerUserInfos';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui';
import routes from '@/lib/routes';
import { cn } from '@/lib/utils';
import type { TProps } from '.';

const UserCardFooter = ({ user, onClickBtnSee, onClickBtnDelete }: Omit<TProps, 'className'>) => {

	const navigate = useNavigate();

	const handleOnClickBtnSee = () => {
		onClickBtnSee
			? onClickBtnSee(user)
			: navigate(routes.nav.users.single.getHref(user._id));
	};

	return (
		<div className={'flex flex-col space-y-2 p-2'}>
			<BannerUserInfos
				useSingleCharGender
				user={user}
				usernameProps={{
					hideAge: true
				}} />
			
			<div className={cn(
				'grid grid-cols-1',
				onClickBtnDelete && 'grid grid-cols-2 gap-2'
			)}>
				<Button
					size={'sm'}
					onClick={handleOnClickBtnSee}
					title='Voir les détails du compte'
					className={'text-blue-600 bg-blue-100 hover:bg-blue-200/80'}>
					Voir
				</Button>
				{
					onClickBtnDelete &&
					<Button
						size={'sm'}
						variant={'destructive'}
						onClick={() => onClickBtnDelete(user)}
						title='Supprimer le compte utilisateur'>
						Supprimer
					</Button>
				}
			</div>
		</div>
	);

};

export default UserCardFooter;
